"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var CameraFill = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M14.2667,3.9997 C14.8017,3.9997 15.2987,4.2867 15.5657,4.7497 L15.5657,4.7497 L16.2887,5.9997 L19.4997,5.9997 C20.3267,5.9997 20.9997,6.6727 20.9997,7.4997 L20.9997,7.4997 L20.9997,17.4997 C20.9997,18.3267 20.3267,18.9997 19.4997,18.9997 L19.4997,18.9997 L4.4997,18.9997 C3.6727,18.9997 2.9997,18.3267 2.9997,17.4997 L2.9997,17.4997 L2.9997,7.4997 C2.9997,6.6727 3.6727,5.9997 4.4997,5.9997 L4.4997,5.9997 L7.7177,5.9997 L8.4837,4.7267 C8.7527,4.2787 9.2447,3.9997 9.7687,3.9997 L9.7687,3.9997 Z M11.9997,7.9997 C9.7947,7.9997 7.9997,9.7937 7.9997,11.9997 C7.9997,13.2657 8.6107,14.4697 9.6337,15.2227 C10.3287,15.7347 11.1517,15.9987 11.9997,15.9987 C12.4177,15.9987 12.8427,15.9347 13.2607,15.8047 C14.4577,15.4327 15.4327,14.4577 15.8047,13.2607 C16.1997,11.9937 15.9877,10.6717 15.2227,9.6327 C14.4707,8.6107 13.2657,7.9997 11.9997,7.9997 Z M12,9 C12.949,9 13.853,9.458 14.418,10.226 C14.992,11.006 15.149,12.003 14.85,12.964 C14.574,13.852 13.851,14.573 12.964,14.85 C12.003,15.148 11.004,14.991 10.226,14.417 C9.458,13.853 9,12.949 9,12 C9,10.346 10.346,9 12,9 Z", fillRule: "evenodd" })));
};
CameraFill.displayName = 'CameraFill';
exports.default = CameraFill;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=CameraFill.js.map